export default __webpack_public_path__ + "static/cordyhover-988a832089f187c440e9e14399ba0927.png";